import AppCard from '@crema/core/AppCard';
import AppScrollbar from '@crema/core/AppScrollbar';
import { ArrowBack } from '@mui/icons-material';
import { Box, Breadcrumbs, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchError, fetchSuccess, showMessage } from 'redux/actions';
import { API } from 'shared/constants/AppEnums';
import DialogKonfirmasi from 'shared/components/DialogKonfirmasi';
import {
  onChangeFilter,
  onRejectDokumenDigisign,
} from 'redux/actions/DigitalSign';
import { useAuthUser, useAuthMethod } from '@crema/utility/AuthHooks';
import AppInfoView from '@crema/core/AppInfoView';

const SignDokumenSk = (props) => {
  const dispatch = useDispatch();
  const { user } = useAuthUser();
  const { setUser } = useAuthMethod()
  const navigation = useNavigate();
  const { type, id } = useParams();
  const { pathname, search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const { detail } = useSelector((state) => state.digiSign);

  const [toggleReject, setToggleReject] = useState(false);

  const isBypass = user.roles_coofis.some(
    (item) => item.state === 'BYPASS_PASSPHRASE',
  );

  useEffect(() => {
    window.addEventListener('message', function (event) {
      if (event.data.status === 'berhasil') {
        let type = queryParams.get('type');
        dispatch(showMessage(event.data.message));
        localStorage.removeItem('attachment');
        localStorage.removeItem('id_document');
        localStorage.removeItem('url');
        localStorage.removeItem('label');
        localStorage.removeItem('type');
        localStorage.removeItem('nip');
        setUser({
          ...user,
          is_bypass: isBypass && event.data.bypass ? event.data.bypass : false
        })
        setTimeout(() => {
          dispatch(onChangeFilter('completed'));
          navigation(`/apps/dokumen-sk?type=${type}`);
        }, 3000);
      } else if (event.data.status === 'errorBypass') {
        setUser({
          ...user,
          is_bypass: false
        })
        dispatch(fetchError(event.data.message))
      } else if (event.data.status === 'error') {
        dispatch(fetchError(event.data.message));
      } else if (event.data.status === 'reject') {
        setToggleReject(true);
      }
    });
  }, [window.addEventListener]);

  const setDocumentType = (input) => {
    switch (input) {
      case 'sdmao':
        return 'dokumen-sk';
      case 'ppid':
        return 'dokumen-ppid';
      case 'dirjend':
        return 'dokumen-dirjend';
      default:
        return 'dokumen-sk';
    }
  };

  useEffect(() => {
    if (pathname === '/apps/dokumen-sk/tanda-tangan') {
      const iframe = document.querySelector('iframe');
      if (detail !== null) {
        localStorage.setItem('attachment', detail.attachments[0].file);
        localStorage.setItem('id_document', detail.id);
        localStorage.setItem('url', API.PUT_INPROGRESS_DOKUMENLAIN_DIGISIGN);
        localStorage.setItem('label', detail.label);
        localStorage.setItem('type', setDocumentType(props.tipeDokumen));
        localStorage.setItem('nip', user.nip);
        localStorage.setItem('isBypass', isBypass);
      }

      iframe.contentWindow.postMessage(
        {
          attachment:
            detail !== null
              ? detail.attachments[0].file
              : localStorage.getItem('attachment'),
          id_document:
            detail !== null ? detail.id : localStorage.getItem('id_document'),
          url: API.PUT_INPROGRESS_DOKUMENLAIN_DIGISIGN,
          label: detail !== null ? detail.label : localStorage.getItem('label'),
          type: setDocumentType(props.tipeDokumen),
          nip: user.nip,
          isBypass: isBypass,
        },
        '*',
      );
    }
  }, [pathname]);

  const handleReject = (status = 0) => {
    if (status === 1) {
      dispatch(onRejectDokumenDigisign({ id_documents: [detail.id] }));
      setTimeout(() => {
        dispatch(onChangeFilter('inProgress'));
        navigation('/apps/dokumen-sk');
      }, 2000);
      setToggleReject(false);
    } else {
      setToggleReject(false);
    }
  };

  const renderBreadcrumb = () => {
    return (
      <Breadcrumbs aria-label='breadcrumb'>
        <Typography
          sx={{
            cursor: 'pointer',
            fontWeight: pathname === '/apps/dokumen-sk' ? 'bold' : '500',
          }}
          color={'primary.default'}
          variant='h3'
          onClick={() => {
            navigation(`/apps/dokumen-sk`);
          }}
        >
          Dokumen Sk
        </Typography>

        {pathname === `/apps/dokumen-sk/tambah-dokumen/${type}` ? (
          <Typography
            color={'primary.default'}
            sx={{ cursor: 'pointer' }}
            variant='h3'
            fontWeight={'bold'}
          >
            Tambah
          </Typography>
        ) : pathname === `/apps/dokumen-sk/tambah-dokumen/${type}/${id}` &&
          id !== undefined ? (
          <Typography
            color={'primary.default'}
            sx={{ cursor: 'pointer' }}
            variant='h3'
            fontWeight={'bold'}
          >
            Ubah Draft
          </Typography>
        ) : pathname === '/apps/dokumen-sk/tanda-tangan' ? (
          <Typography
            color={'primary.default'}
            sx={{ cursor: 'pointer' }}
            variant='h3'
            fontWeight={'bold'}
          >
            Tanda Tangan
          </Typography>
        ) : id !== undefined && pathname === `/apps/dokumen-sk/detail/${type}/${id}` ? (
          <Typography
            color={'primary.default'}
            sx={{ cursor: 'pointer' }}
            variant='h3'
            fontWeight={'bold'}
          >
            Detail
          </Typography>
        ) : null}
      </Breadcrumbs>
    );
  };

  return (
    // detail !== null ? (
    //     <Stack direction='column' spacing={4} height={'100% !important'}>
    //         <AppCard sxStyle={{ backgroundColor: 'white !important', height: '100% !important' }}>
    //             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    //                 <Box>
    //                     <Tooltip title={'Kembali'} placement='top' arrow>
    //                         <IconButton onClick={() => navigation(-1)}>
    //                             <ArrowBack />
    //                         </IconButton>
    //                     </Tooltip>
    //                 </Box>
    //             </Box>
    //             <iframe
    //                 style={{ width: '100%', height: '100%', minHeight: '70vh', border: 0, }}
    //                 src={"/assets/pdfViewer/index.html"}
    //             >
    //             </iframe>
    //         </AppCard>
    //     </Stack>
    // ) : null
    <Stack direction='column' spacing={2} height={'100vh !important'}>
      <AppInfoView />

      {renderBreadcrumb()}

      <AppCard
        sxStyle={{
          backgroundColor: 'white !important',
          height: '100% !important',
        }}
        contentStyle={{ display: 'flex', flexDirection: 'column' }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box>
            <Tooltip title={'Kembali'} placement='top' arrow>
              <IconButton onClick={() => navigation(-1)}>
                <ArrowBack />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Divider sx={{ mt: 2 }} />

        <iframe
          style={{ flex: 1, border: 0 }}
          src={'/assets/pdfViewer/index.html'}
        ></iframe>

        <DialogKonfirmasi
          open={toggleReject}
          handleClose={handleReject}
          labelPesan='Tolak Dokumen'
          isiPesan={'Apakah anda yakin akan menolak dokumen berikut?'}
          labelTombol='Tolak'
        />
      </AppCard>
    </Stack>
  );
};

SignDokumenSk.propTypes = {
  tipeDokumen: PropTypes.string,
};

export default SignDokumenSk;
